/* import __COLOCATED_TEMPLATE__ from './notify-slack-channel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();